<!--
<div class="row drawer-content-header pt-4">
  <div class="col">
    <primary-text-button (onClick)="submit()"
      [disabled]="(!service.name || (service.name && service.name.length < 2))">
      {{ 'Save' | translate }}
    </primary-text-button>
    <cancelary-text-button (click)="closeLayer()" [noRightMargin]="true">
      {{ 'Cancel' | translate }}
    </cancelary-text-button>
  </div>
</div>
-->

<div class="row drawer-content drawer-direct-content mt-4">
  <div class="col settings-container d-flex flex-column" [ngClass]="{'hidden': !isLoading}">
    <i class="fad fa-spin fa-spinner-third"></i>
  </div>
  <div class="col settings-container d-flex flex-column" [ngClass]="{'hidden': isLoading}">
    <div class="settings-tabs-container no-sticky" id="tabsContainer">
      <ul role="tablist" class="nav nav-tabs new-tabs dropdown-tabs" id="tabsResp">
        <li class="dropdown active" dropdown>
          <a class="" href="#" (click)="false" dropdownToggle>
            <span [ngClass]="{'hidden': currentRoute !== 'configuration'}">{{ 'Service configuration' | translate }}</span>
            <span [ngClass]="{'hidden': currentRoute !== 'options' && (!service.isMyAccountPage)}">{{ 'Service options' | translate }}</span>
            <span [ngClass]="{'hidden': currentRoute !== 'history'}">{{ 'service.publish_history' | translate }}</span>
            <span [ngClass]="{'hidden': currentRoute !== 'export'}">{{ 'Export service' | translate }}</span>
            <span [ngClass]="{'hidden': currentRoute !== 'databases'}">{{ 'Databases' | translate }}</span>
            <span [ngClass]="{'hidden': currentRoute !== 'debug'}">{{ 'Debugging' | translate }}</span>
            <i class="fas fa-angle-down ml-3"></i>
            <i class="fas fa-angle-up ml-3"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-left" *dropdownMenu>
            <a [ngClass]="{'hidden': currentRoute === 'configuration'}" (click)="updateCurrentRoute('configuration');" class="dropdown-item py-2">
              <span>{{ 'Service configuration' | translate }}</span>
            </a>
            <a [ngClass]="{'hidden': currentRoute === 'options' || (service.isMyAccountPage)}" (click)="updateCurrentRoute('options');" class="dropdown-item py-2">
              <span>{{ 'Service options' | translate }}</span>
            </a>
            <a [ngClass]="{'hidden': currentRoute === 'history'}" (click)="updateCurrentRoute('history');" class="dropdown-item py-2">
              <span>{{ 'service.publish_history' | translate }}</span>
            </a>
            <a [ngClass]="{'hidden': currentRoute === 'export'}" (click)="updateCurrentRoute('export');" class="dropdown-item py-2">
              <span>{{ 'Export service' | translate }}</span>
            </a>
            <a [ngClass]="{'hidden': currentRoute === 'databases'}" (click)="updateCurrentRoute('databases');" class="dropdown-item py-2">
              <span>{{ 'Databases' | translate }}</span>
            </a>
            <a [ngClass]="{'hidden': currentRoute === 'debug'}" (click)="updateCurrentRoute('debug');" class="dropdown-item py-2">
              <span>{{ 'Debugging' | translate }}</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
    <div id="myTabContent" class="tab-content top-left-square-border border-0">
      <div id="conf" role="tabpanel" class="tab-pane fade py-3 px-4 active show">
        <form name="itemForm" role="form" *ngIf="currentRoute === 'configuration'">
          <div class="row">
            <div class="col px-4">
              <div class="form-group">
                <label class="input-label field-required">{{ service.id ? 'Service name' : 'New service name' | translate }}</label>
                <input class="form-control font-weight-bold mb-1" placeholder="{{ 'New service name' | translate }}"
                  [(ngModel)]="service.name" #name="ngModel" type="text" name="title" [rangeLength]="[2, 256]" required
                  autofocus />
                <p class="validation-error my-1" *ngIf="name.errors?.required && (name?.dirty && name?.touched)">
                  {{ 'form.validate.required' | translate }}
                </p>
                <p class="validation-error my-1" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
                  {{ 'form.validate.minLenght' | translate }} 2!
                </p>
                <p class="validation-error my-1" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
                  {{ 'form.validate.maxLenght' | translate }} 256!
                </p>
              </div>
            </div>
          </div>
          <service-settings-configuration
            [service]="service"
            [guideTypesOptions]="guideTypesOptions"
            [guideTypesEnum]="guideTypesEnum">
          </service-settings-configuration>
        </form>
        <service-settings-options *ngIf="currentRoute === 'options'"
          [service]="service"
          [services]="services"
          class="d-block w-100">
        </service-settings-options>
        <service-settings-history *ngIf="currentRoute === 'history'" [service]="service" class="d-block w-100"></service-settings-history>
        <service-settings-export *ngIf="currentRoute === 'export'" [service]="service" class="d-block w-100"></service-settings-export>
        <service-settings-databases *ngIf="currentRoute === 'databases'" [service]="service" class="d-block w-100"></service-settings-databases>
        <service-settings-debug *ngIf="currentRoute === 'debug'" [service]="service" class="d-block w-100"></service-settings-debug>
      </div>
    </div>
  </div>
</div>
